module.exports = __webpack_public_path__ + "img/Dantam Makeover 32.b2579e3f.jpg";